<div class="sg-cookies-settings-dialog-container">
  <div mat-dialog-title class="dialog-title-full-width">
    <sg-text variant="sg-h2-standard" class="dialog-title-text">Cookies Preferences</sg-text>
    <sg-button icon="close" variant="ghost-secondary" size="medium" mat-dialog-close></sg-button>
  </div>
  <div mat-dialog-content class="dialog-content dialog-content-full-width"><sg-cookies-settings [formControl]="customSettings"></sg-cookies-settings></div>
  <div mat-dialog-actions align="end">
    <sg-button text="Discard" variant="ghost-secondary" size="medium" [disabled]="tracker.busy$ | async" (onClick)="closeDialog()"></sg-button>
    <sg-button text="Save" variant="primary" size="medium" [disabled]="tracker.busy$ | async" (onClick)="agreeUserConsent()"></sg-button>
  </div>
</div>
